import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "gw-unfold-less",
  "use": "gw-unfold-less-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"gw-unfold-less\"><path fill=\"none\" d=\"M0 0h24v24H0Z\" /><path d=\"M8.12 19.3c.39.39 1.02.39 1.41 0L12 16.83l2.47 2.47a.996.996 0 1 0 1.41-1.41l-3.17-3.17a.996.996 0 0 0-1.41 0l-3.17 3.17c-.4.38-.4 1.02-.01 1.41m7.76-14.6a.996.996 0 0 0-1.41 0L12 7.17 9.53 4.7a.996.996 0 0 0-1.41 0c-.39.39-.39 1.03 0 1.42l3.17 3.17c.39.39 1.02.39 1.41 0l3.17-3.17c.4-.39.4-1.03.01-1.42\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol